// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu_menuContainer__MT4jZ","icon":"Menu_icon__CC4J9","iconBack":"Menu_iconBack__V9v5d"};